"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function SocialAuth(prop) {
    console.log("".concat(process.env.REACT_APP_DIRECTUS_BACKEND, "/auth/login/google?redirect=").concat(window.location.href));
    //return window.location.href = `${process.env.REACT_APP_DIRECTUS_BACKEND}/auth/login/${prop.type}?redirect=${window.location.href}`;
    return window.location.href = "".concat(process.env.REACT_APP_DIRECTUS_BACKEND, "/auth/login/google?redirect=").concat(window.location.href);
}
exports.default = SocialAuth;
